import React from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { useBrand } from '../context/BrandContext';
import '../styles/Sidebar.css';

const Sidebar = () => {
  const navigate = useNavigate();
  const brand = useBrand();
  const user = JSON.parse(localStorage.getItem('user') || '{}');

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/');
  };

  return (
    <aside className="sidebar">
      <div className="sidebar-header">
        <Link to="/dashboard" className="sidebar-logo">
          <div className="logo-icon">
            <i className="fas fa-broadcast-tower"></i>
          </div>
          <div className="logo-text">
            <span className="logo-title">{brand.companyName}</span>
            <span className="logo-subtitle">{brand.productShortName}</span>
          </div>
        </Link>
      </div>

      <nav className="sidebar-nav">
        <NavLink 
          to="/dashboard" 
          className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
          end
        >
          <i className="fas fa-home"></i>
          <span>Dashboard</span>
        </NavLink>

        <NavLink 
          to="/dashboard/upload" 
          className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
        >
          <i className="fas fa-cloud-upload-alt"></i>
          <span>Upload File</span>
        </NavLink>

        <NavLink 
          to="/dashboard/reports" 
          className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
        >
          <i className="fas fa-chart-line"></i>
          <span>Reports</span>
        </NavLink>

        <NavLink 
          to="/dashboard/schedule-emails" 
          className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
        >
          <i className="fas fa-clock"></i>
          <span>Scheduled Emails</span>
        </NavLink>

        <NavLink 
          to="/dashboard/settings" 
          className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
        >
          <i className="fas fa-cog"></i>
          <span>Settings</span>
        </NavLink>

        {user?.role === 'master_admin' && (
          <>
            <NavLink
              to="/dashboard/subscription"
              className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
            >
              <i className="fas fa-sync-alt"></i>
              <span>Subscription</span>
            </NavLink>
            <NavLink
              to="/dashboard/support"
              className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
            >
              <i className="fas fa-life-ring"></i>
              <span>Support</span>
            </NavLink>
            <NavLink
              to="/dashboard/usage"
              className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
            >
              <i className="fas fa-chart-pie"></i>
              <span>AI Usage</span>
            </NavLink>
            <NavLink
              to="/dashboard/manage-staff"
              className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
            >
              <i className="fas fa-users-cog"></i>
              <span>Manage Staff</span>
            </NavLink>
            <NavLink
              to="/dashboard/activity"
              className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
            >
              <i className="fas fa-clipboard-list"></i>
              <span>Activity Logs</span>
            </NavLink>
          </>
        )}
      </nav>

      <div className="sidebar-footer">
        <div className="user-info">
          <div className="user-avatar">
            <i className="fas fa-user"></i>
          </div>
          <div className="user-details">
            <span className="user-name">{user?.full_name || 'User'}</span>
            <span className="user-email">{user?.email || ''}</span>
          </div>
        </div>

        <button className="btn-logout" onClick={handleLogout}>
          <i className="fas fa-sign-out-alt"></i>
          <span>Logout</span>
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;
